import React, { ReactNode } from 'react';
import styled from 'styled-components';

import mq from '../../../styles/breakpoints';
import { Body, IntroText } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

import OkayIcon from '../../../images/okay-checkmark-icon.svg';

interface Props {
  title?: string;
  subtitle?: ReactNode;
  open: boolean;
  children?: ReactNode;
}

const FormResultBody = ({ title, subtitle, open, children }: Props) =>
  open && (
    <Container>
      <ResultHeader>
        <ImageWrapper>
          <Image src={OkayIcon} />
        </ImageWrapper>
        {(title || subtitle) && (
          <NonMobileCopyWrapper>
            {title && <IntroText>{title}</IntroText>}
            {subtitle && <Body>{subtitle}</Body>}
          </NonMobileCopyWrapper>
        )}
        {title && <MobileTitle>{title}</MobileTitle>}
        {subtitle && <MobileBody>{subtitle}</MobileBody>}
      </ResultHeader>
      <CardWrapper>{children}</CardWrapper>
    </Container>
  );

export default FormResultBody;

const Container = styled.div`
  margin: 0 -${Spacings.S};

  ${mq.from.breakpoint.M`
    margin: initial;
  `}
`;

const ResultHeader = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: ${Spacings.S};
  padding: ${Spacings.S};

  ${mq.from.breakpoint.M`
    padding: 0;
    flex-wrap: nowrap;
  `}
`;

const NonMobileCopyWrapper = styled.div`
  display: none;

  ${mq.from.breakpoint.M`
    max-width: 1064px;
    display: block;
  `}
`;

const ImageWrapper = styled.div`
  flex-shrink: 0;
  height: 80px;
  width: 80px;
`;

const Image = styled.img`
  display: block;
  height: 100%;
  width: 100%;
`;

const CardWrapper = styled.div`
  margin-top: ${Spacings.XL};

  > div,
  > section {
    margin-bottom: ${Spacings.M};

    &:last-of-type {
      margin-bottom: ${Spacings.S};
    }
  }
`;

const MobileTitle = styled(IntroText)`
  display: block;
  flex: 1;

  ${mq.from.breakpoint.M`
    display: none;
  `}
`;

const MobileBody = styled(Body)`
  display: block;
  width: 100%;

  ${mq.from.breakpoint.M`
    display: none;
  `}
`;
